// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { RestError, isRestError } from "@azure/core-rest-pipeline";

export type { PollOperationState, PollerLike } from "@azure/core-lro";
export * from "./BlobServiceClient.js";
export * from "./Clients.js";
export * from "./ContainerClient.js";
export * from "./BlobLeaseClient.js";
export * from "./sas/AccountSASPermissions.js";
export * from "./sas/AccountSASResourceTypes.js";
export * from "./sas/AccountSASServices.js";
export {
  type AccountSASSignatureValues,
  generateAccountSASQueryParameters,
} from "./sas/AccountSASSignatureValues.js";
export * from "./BlobBatch.js";
export * from "./BlobBatchClient.js";
export type * from "./BatchResponse.js";
export * from "./sas/BlobSASPermissions.js";
export {
  type BlobSASSignatureValues,
  generateBlobSASQueryParameters,
} from "./sas/BlobSASSignatureValues.js";
export * from "./sas/ContainerSASPermissions.js";
export type { SasIPRange } from "./sas/SasIPRange.js";
export type { Range } from "./Range.js";
export {
  type BlobClientOptions,
  type AppendBlobClientOptions,
  type BlockBlobClientOptions,
  type PageBlobClientOptions,
  type ContainerClientOptions,
  type BlobServiceClientOptions,
  type BlobClientConfig,
  BlockBlobTier,
  PremiumPageBlobTier,
  type Tags,
  type BlobDownloadResponseParsed,
  type BlobImmutabilityPolicy,
  type ObjectReplicationPolicy,
  type ObjectReplicationRule,
  type ObjectReplicationStatus,
  type BlobQueryArrowField,
  type BlobQueryArrowFieldType,
  type HttpAuthorization,
  StorageBlobAudience,
  type PollerLikeWithCancellation,
  getBlobServiceAccountAudience,
} from "./models.js";
export type { NodeJSReadableStream } from "@azure/storage-common";
export { StorageResponseFormat } from "@azure/storage-common";
export {
  Pipeline,
  type PipelineLike,
  type PipelineOptions,
  isPipelineLike,
  newPipeline,
  type StoragePipelineOptions,
  type RequestPolicyFactory,
  type RequestPolicy,
  type RequestPolicyOptions,
  type WebResource,
  type HttpOperationResponse,
  type HttpHeaders,
  type HttpRequestBody,
  type IHttpClient,
  StorageOAuthScopes,
  type ServiceClientOptions,
} from "./Pipeline.js";
export {
  AnonymousCredential,
  AnonymousCredentialPolicy,
  BaseRequestPolicy,
  CredentialPolicy,
  Credential,
  StorageRetryPolicyType,
  StorageRetryPolicy,
  type StorageRetryOptions,
  StorageRetryPolicyFactory,
  StorageSharedKeyCredential,
  StorageSharedKeyCredentialPolicy,
  StorageBrowserPolicy,
  StorageBrowserPolicyFactory,
  type UserDelegationKey,
  type CredentialPolicyCreator,
} from "@azure/storage-common";
export * from "./sas/SASQueryParameters.js";
export type { CommonOptions } from "./StorageClient.js";
export * from "./generatedModels.js";
export type {
  AppendBlobRequestConditions,
  BlobRequestConditions,
  Metadata,
  PageBlobRequestConditions,
  TagConditions,
  ContainerRequestConditions,
  ModificationConditions,
  MatchConditions,
  ModifiedAccessConditions,
  StorageChecksumAlgorithm,
  AccessTierModifiedConditions,
  RequestHeaders,
  RequestQueryParameters,
} from "./models.js";
export { RestError, isRestError };
export type {
  PageBlobGetPageRangesDiffResponse,
  PageBlobGetPageRangesResponse,
  PageList,
} from "./PageBlobRangeResponse.js";
export { logger } from "./log.js";
export type {
  BlobBeginCopyFromUrlPollState,
  CopyPollerBlobClient,
} from "./pollers/BlobStartCopyFromUrlPoller.js";
